import TeacherSubjectCode from '@/api/teacher-subject-code'
import TeacherProfile from '@/api/teacher-profile'
import AcademicYear from '@/api/academic-year'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  academicYears: [],
  teachers: [],
  subjects: []
}

export const getters = {
  subjectsNotIncludeSelected: state => ({
    addedSubjects,
    excludeSubjectId
  } = {}) => {
    if (addedSubjects !== undefined && excludeSubjectId !== undefined) {
      return state.subjects.filter(
        p =>
          !_.includes(
            addedSubjects
              .filter(t => t.subject_id != excludeSubjectId)
              .map(t => t.subject_id),
            p.subject_id
          )
      )
    }

    return state.subjects
  }
}

export const mutations = {
  ...baseMutations,
  RECEIVE_ACADEMIC_YEARS(state, data) {
    state.academicYears = data
  },
  RECEIVE_TEACHERS(state, data) {
    state.teachers = data
  },
  RECEIVE_SUBJECTS(state, data) {
    state.subjects = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return TeacherSubjectCode.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return TeacherSubjectCode.store(data)
  },
  update(context, { sstc_id, ...data }) {
    return TeacherSubjectCode.update(
      sstc_id,
      Object.assign({}, data, {
        total_hours: parseFloat(data.total_hours)
      })
    )
  },
  destroy(context, id) {
    return TeacherSubjectCode.destroy(id)
  },
  fetchAcademicYear(context, attributes = {}) {
    return AcademicYear.get({
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      },
      params: {
        page: -1,
        fields: {
          academic_years: 'ac_year_id,ac_year'
        },
        ...attributes
      }
    }).then(response => {
      context.commit('RECEIVE_ACADEMIC_YEARS', response.data)
      return Promise.resolve(response)
    })
  },

  fetchTeachers(context, attributes = {}) {
    return TeacherProfile.get({
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      },
      params: {
        page: -1,
        fields: {
          setup_teacher_profiles: 'teacher_id,fname_foreign,lname_foreign'
        },
        ...attributes
      }
    }).then(response => {
      context.commit('RECEIVE_TEACHERS', response.data)
      return Promise.resolve(response)
    })
  },
  async subject(context, teacher_id) {
    let response = await TeacherSubjectCode.subject(teacher_id)
    context.commit('RECEIVE_SUBJECTS', response.data)
    return response
  }
}
